import React from "react";
import "./Banner.css";
import Common_Btn from "../../common-components/common-btn/Common_Btn";

const Banner = () => {
  return (
    <section className="Home-Banner">
      <div className="Image">
        <div className="img_holder">
          <img
            src="/assets/images/Home/Home-page-banner.png"
            alt="Banner"
            className="myImage"
          />
          <div className="mobile_holder">
            <img
              src="/assets/images/Home/mobile-home-banner.png"
              alt="Banner"
              className="mobile_Img"
            />

            <div className="mobile_text_holder">
              <p className="platform_text">Platform for Big Dreams</p>
              <p className="play_big">
                PLAY BIG <br></br>
                <span>AND WIN</span>
              </p>

              <p className="bigger">BIGGER</p>
            </div>
          </div>

          <div className="image_content_holder">
            <Common_Btn
              btnText="Download App"
              onClick={() => window.open("https://play.google.com", "_blank")}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
